export const authBaseDomain = 'https://api-uat.nispand.com'
// export const authBaseDomain = 'https://17b8-203-132-133-126.ngrok-free.app/v2'
// export const authBaseDomain = 'https://17b8-203-132-133-126.ngrok-free.app'
export const authBaseDomainAuth = 'https://api-uat.nispand.com'
export const stage = '/v2'